"use client";

import { useTheme } from "next-themes";
import { CornerTip, cornerLink } from "@/components/corners";

export function SiteNav() {
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <nav aria-label="頁面導覽" className="flex items-center gap-4">
      <CornerTip
        tip={resolvedTheme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        <button
          type="button"
          className={cornerLink}
          onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
        >
          <span className="dark:hidden">Dark</span>
          <span className="hidden dark:inline">Light</span>
        </button>
      </CornerTip>
    </nav>
  );
}
